import React from 'react';
import IconSmile from '@/assets/IconSmile.svg';

import { TRecommendation } from '@/services/requests/Recommendation/types/template6';

type TProps = { data: TRecommendation['header'] };

export const HeaderInformation = ({ data }: TProps) => {
  const { prefix, has_icon: hasIcon, suffix } = data;
  return (
    <>
      <span
        className="vitrine-template6__header--content-title1"
        data-testid="prefix"
      >
        {prefix}
      </span>
      <span
        className="vitrine-template6__header--content-icon"
        data-testid="icon"
      >
        {hasIcon && <img src={IconSmile} alt="Smile" />}
      </span>

      <span className="vitrine-template6__header--content-title2">
        <strong data-testid="suffix">{suffix}</strong>
      </span>
    </>
  );
};
